module.exports = __webpack_public_path__ + "img/03.04bbfd53.png";